@if (!isVoicemail()) {
  <div class="audio-card" [ngClass]="{ 'w-[380px]': previewMode() }" data-e2e="audio-card">
    @if (!isMobile()) {
      <div class="block rounded-full w-8 h-8 flex-shrink-0 my-4 ml-4">
        <i class="mi2-voicemail text-[32px] text-primary"></i>
      </div>
    }
    <div class="audio-card-info">
      <div
        class="font-semibold text-base text-color leading-6 whitespace-nowrap overflow-hidden text-ellipsis"
        title="{{ attachmentName() }}"
        [attr.aria-label]="'cl_chat.fileLabels.audio' | translate: { fileName: attachmentName() }"
      >
        {{ attachmentName() }}
      </div>
      <!-- *ngIf is temporary until we have a proper mobile design for audio cards -->
      @if (!isMobile() && !previewMode()) {
        <button
          class="text-sm text-primary overflow-hidden whitespace-nowrap flex flex-row items-center w-max border-0 bg-transparent p-0 cursor-pointer"
          [ngClass]="{ 'cl-chat-button-disabled': isOffline() }"
          [attr.aria-label]="'cl_chat.clickToDownload' | translate"
          [attr.tabindex]="currentTabIndex()"
          (click)="!isOffline() ? downloadAttachment() : ''"
        >
          <span class="text-ellipsis whitespace-nowrap overflow-hidden focus-visible:rounded-[20%]">
            {{ 'cl_chat.clickToDownload' | translate }} ({{ attachmentSize() }})
          </span>
        </button>
      }

      @if (!isMobile() && previewMode()) {
        <div
          class="text-sm text-primary overflow-hidden whitespace-nowrap flex flex-row items-center w-max cursor-default"
        >
          <span tabindex="-1">
            {{ attachmentSize() }}
          </span>
        </div>
      }

      <div class="audio-card-playing">
        <button
          class="audio-card-playing-button chat-one-app-button"
          role="button"
          [disabled]="previewMode()"
          [attr.tabindex]="currentTabIndex()"
          [attr.aria-label]="'cl_chat.playAudio' | translate"
          [ngClass]="{
            'audio-card-playing-button-mobile': isMobile(),
            'primary-orange': audioObj().audioPlaying,
            'primary-green': !audioObj().audioPlaying
          }"
          [ngStyle]="{ 'box-shadow': 'var(--p-mi-shadow)' }"
          (click)="playAudioMessage(item().clCompChat_displayBody, true)"
        >
          @if (audioObj().audioPlaying) {
            <div class="audio-card-playing-button-stop">
              <i class="mi2-hold-call text-xs text-surface-0"></i>
            </div>
          } @else {
            <div class="audio-card-playing-button-play">
              <i class="mi2-play-filled text-xs text-surface-0"></i>
            </div>
          }
        </button>
        @if (!audioObj().audioPlaying && audioObj().audioProgress == '0%') {
          <div class="audio-placeholder" [ngClass]="{ 'audio-placeholder-mobile': isMobile() }"></div>
        }
        @if (audioLoaded() && audioObj().audioStart && audioObj().audioProgress != '0%') {
          <div class="text-base text-muted-color ml-2.5" title="{{ audioObj().audioStart }}">
            {{ audioObj().audioStart }}
          </div>
        }
        <div
          class="audio-waveforms"
          [ngClass]="{ 'audio-waveforms-mobile': isMobile() }"
          [style.visibility]="audioObj().audioProgress != '0%' ? 'visible' : 'hidden'"
        >
          <canvas #waveformsCanvas></canvas>
          <div
            class="audio-progress"
            [ngClass]="{ 'audio-progress-mobile': isMobile() }"
            [ngStyle]="{ width: audioObj().audioProgress }"
            [style.visibility]="audioObj().audioProgress != '0%' ? 'visible' : 'hidden'"
          >
            <div class="canvas-container" #progressCanvas></div>
          </div>
        </div>
        @if (audioLoaded() && audioObj().audioStart && audioObj().audioProgress != '0%') {
          <div class="text-base text-muted-color ml-2.5" title="{{ audioObj().audioEnd }}">
            {{ audioObj().audioEnd }}
          </div>
        }
      </div>
    </div>
  </div>
}
@if (!isVoicemail()) {
  <audio class="hidden" controls #audio preload="none" (timeupdate)="audioUpdateTime()">
    <source src="" type="audio/wav" />
  </audio>
}

@if (isVoicemail()) {
  <div class="audio-card" data-e2e="audio-card">
    @if (!isMobile()) {
      <div class="block rounded-full w-8 h-8 flex-shrink-0 my-4 ml-4">
        <i class="mi2-voicemail text-[32px] text-primary"></i>
      </div>
    }
    <div
      class="audio-card-info"
      [ngClass]="{
        'audio-card-info-preview-mode': previewMode()
      }"
    >
      <div
        class="font-semibold text-base text-color leading-6 whitespace-nowrap overflow-hidden text-ellipsis"
        title="{{ 'cl_chat.voicemail' | translate }}"
      >
        {{ record()?.fromName }} - {{ record()?.from }}
      </div>
      <div class="audio-card-playing">
        <button
          class="audio-card-playing-button chat-one-app-button"
          role="button"
          (click)="playAudioMessage(item().clCompChat_displayBody, false)"
          [attr.tabindex]="currentTabIndex()"
          (keydown.enter)="playAudioMessage(item().clCompChat_displayBody, false)"
          [attr.aria-label]="'cl_chat.playAudio' | translate"
          [ngClass]="{
            'audio-card-playing-button-mobile': isMobile(),
            'primary-orange': audioObj().audioPlaying,
            'primary-green': !audioObj().audioPlaying
          }"
          [ngStyle]="{ 'box-shadow': 'var(--p-mi-shadow)' }"
        >
          @if (audioObj().audioPlaying) {
            <div class="audio-card-playing-button-stop">
              <i class="mi2-hold-call text-xs text-surface-0"></i>
            </div>
          } @else {
            <div class="audio-card-playing-button-play">
              <i class="mi2-play-filled text-xs text-surface-0"></i>
            </div>
          }
        </button>
        @if (!audioObj().audioPlaying && audioObj().audioProgress == '0%') {
          <div class="audio-placeholder" [ngClass]="{ 'audio-placeholder-mobile': isMobile() }"></div>
        }
        @if (audioLoaded() && audioObj().audioStart && audioObj().audioProgress != '0%') {
          <div class="text-base text-muted-color ml-2.5" title="{{ audioObj().audioStart }}">
            {{ audioObj().audioStart }}
          </div>
        }
        <div
          class="audio-waveforms"
          [ngClass]="{ 'audio-waveforms-mobile': isMobile() }"
          [style.visibility]="audioObj().audioProgress != '0%' ? 'visible' : 'hidden'"
        >
          <canvas #waveformsCanvas></canvas>
          <div
            class="audio-progress"
            [ngClass]="{ 'audio-progress-mobile': isMobile() }"
            [ngStyle]="{ width: audioObj().audioProgress }"
            [style.visibility]="audioObj().audioProgress != '0%' ? 'visible' : 'hidden'"
          >
            <div class="canvas-container" #progressCanvas></div>
          </div>
        </div>
        @if (audioLoaded() && audioObj().audioStart && audioObj().audioProgress != '0%') {
          <div class="text-base text-muted-color ml-2.5" title="{{ audioObj().audioEnd }}">
            {{ audioObj().audioEnd }}
          </div>
        }
      </div>
    </div>
  </div>
}

@if (isVoicemail()) {
  <audio class="hidden" controls #audio preload="none" (timeupdate)="audioUpdateTime()">
    <source src="" type="audio/mpeg" />
  </audio>
}
